import { observer } from 'mobx-react';
import { FC } from 'react';
import ProductModifier from '../../components/ProductModifier/ProductModifier';
import { orderProductModalStore } from '../../store/orderProductModalStore';

const ProductModifiers: FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.product || orderProductModalStore.loadingProduct) return null;

  return (
    <div className="d-flex flex-column mb-4 gap-15">
      {orderProductModalStore.product?.modifiers.map((modifier) => (
        <ProductModifier
          key={modifier.id}
          modifier={modifier}
          isModifierWithError={orderProductModalStore.modifiersWithError.includes(String(modifier.id))}
          onChangeModifier={orderProductModalStore.onChangeModifier}
        />
      ))}
    </div>
  );
});

export default ProductModifiers;
